import React from "react";
import { connect } from "react-redux";
import { getUserCustomers, mapPrimaryAccountType } from "../../actions/UserActions";
import { updateState } from "../../actions/CommonActions";
import * as types from "../../constants/ActionTypes";
import { clearSessionPaymentMethods } from "../../reducers/PaymentReducer";
import { canImpersonate } from "../../PermissionSelectors";

class UserImpersonate extends React.Component {
    onCheckClick = () => {
        const { user, impersonatedUserId, dispatch, currentUser } = this.props;

        if (user.UserId !== impersonatedUserId) {
            // Start impersonation
            sessionStorage.setItem("impersonatedUserId", user.UserId);
            (getUserCustomers(dispatch, user.UserId));
            (updateState(dispatch, types.SET_ACCOUNT_TYPE, mapPrimaryAccountType(user.PrimaryAccountTypeId)));
        } else {
            // Stop impersonation
            sessionStorage.setItem("impersonatedUserId", "");
            (getUserCustomers(dispatch, ""));
            (updateState(dispatch, types.SET_ACCOUNT_TYPE, mapPrimaryAccountType(currentUser.PrimaryAccountTypeId)));
        }

        dispatch(clearSessionPaymentMethods());
    };

    render() {
        const { user, impersonatedUserId, canImpersonate } = this.props;
        const isChecked = user.UserId === impersonatedUserId;

        return (
            <div>
                {canImpersonate && (
                    <input
                        className="rounded-circle"
                        type="checkbox"
                        onChange={this.onCheckClick}
                        checked={isChecked}
                        id={user.UserId}
                        name={user.UserId}
                        disabled={user.Accounts.length <= 0}
                    />
                )}
            </div>
        );
    }
}

export default connect((state, props) => ({
    impersonatedUserId: state.user_options.impersonatedUserId,
    currentUser: state.default.currentUser,
    canImpersonate: canImpersonate(state, props),
}))(UserImpersonate);
